"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChrome = exports.isEdgeChromium = void 0;
/**
 * Chromium版Edgeブラウザかどうかを判定する
 *
 * #### インポート
 * ```typescript
 * import { isEdgeChromium } from 'rj_frontend_common/dist/utils/browserJudgment';
 * ```
 * @returns 判定結果
 */
const isEdgeChromium = () => {
    return BrowserJudgment.getBrowseType() === BrowserJudgment.BrowseType.EdgeChromium;
};
exports.isEdgeChromium = isEdgeChromium;
/**
 * Chromeブラウザかどうかを判定する
 *
 * #### インポート
 * ```typescript
 * import { isChrome } from 'rj_frontend_common/dist/utils/browserJudgment';
 * ```
 * @returns 判定結果
 */
const isChrome = () => {
    return BrowserJudgment.getBrowseType() === BrowserJudgment.BrowseType.Chrome;
};
exports.isChrome = isChrome;
/** ブラウザ判定 */
class BrowserJudgment {
}
/** ブラウザ種別 */
BrowserJudgment.BrowseType = {
    /** chromium版Edge */
    EdgeChromium: 'edgeChromium',
    /** Chrome */
    Chrome: 'chrome',
};
/**
 * userAgentからブラウザを判定する
 * @returns ブラウザ種別 判定できない場合は空文字を返す
 */
BrowserJudgment.getBrowseType = () => {
    const agent = window.navigator.userAgent.toLocaleLowerCase();
    if (agent.includes('edg/')) {
        // Edge
        return BrowserJudgment.BrowseType.EdgeChromium;
    }
    else if (agent.includes('opr') || agent.includes('opera')) {
        // Opera（エージェント情報に文字列'chrome'が含まれるためこの順で判定）
        return '';
    }
    else if (agent.includes('chrome')) {
        // Chrome
        return BrowserJudgment.BrowseType.Chrome;
    }
    else {
        // 該当なし
        return '';
    }
};
